import RelevesBonsImpressionController from './releves.bons.impression.controller';

export default {
	template: require('./releves.bons.impression.template.html'),
	controller: RelevesBonsImpressionController,
	bindings: {}
};
